export const breadcrumbNameMap = {
  "/account": "Account",
  "/approvals": "Approvals",
  "/approved-invoices": "Approved Invoices",
  "/approved-orders": "Approved Orders",
  "/balance": "Account Balance",
  "/completed-orders": "Completed Orders",
  "/contracts": "Contracts",
  "/credit": "Credit",
  "/credit/outstanding": "Outstanding",
  "/credit/settled": "Settled",
  "/draft-orders": "Draft Orders",
  "/draft-requests": "Draft Requests",
  "/draft": "Draft Order",
  "/entitlement": "Entitlement",
  "/entitlement/complete": "Complete",
  "/entitlement/exceeded": "Exceeded",
  "/entitlement/predicted": "Predicted",
  "/entitlement/remaining": "Remaining",
  "/invoices": "Invoices",
  "/invoices/outstanding": "Outstanding",
  "/invoices/settled": "Settled",
  "/items": "Items",
  "/logout": "Logout",
  "/received-orders": "Received Orders",
  "/received": "Received Orders",
  "/reports": "Reports",
  "/reports/financial": "Financial",
  "/reports/general": "General",
  "/request": "Request",
  "/request-history": "Request History",
  "/returns": "Returns",
  "/returns/completed": "Completed",
  "/returns/new": "New Return",
  "/returns/pending": "Pending",
  "/staff": "Staff All",
  "/staff/add": "Staff Add",
  "/staff/active": "Staff Active",
  "/staff/inactive": "Staff Inactive",
  "/submitted-requests": "Submitted Requests",
  "/support": "Support",
  "/unauthorised": "Unauthorised",
  "/wardrobe-request": "Wardrobe Request",
  "/wardrobes": "Wardrobes",
  "/draft-bulk": "Bulk Order",
};
